import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';
import { useDebt } from '../../context';
import Typography from 'components/generics/texts/Typography';
import { OrderKind } from '../../../../../../consts/enums/order';
import classes from 'components/generics/forms/DebtForm/components/DebtFormTitle/index.module.scss';
import InfoTooltip from '../../../../../features/InfoTooltip';

interface DebtTitleProps extends HTMLAttributes<HTMLDivElement> {
  redemptionSharesValidAmount?: number;
}

const DebtFormTitle = ({
  className,
  redemptionSharesValidAmount,
}: DebtTitleProps) => {
  const { orderKind } = useDebt();

  return (
    <div className={classNames(classes.container, className)}>
      <Typography className={classes.text}>
        {orderKind === OrderKind.BUY ? 'Buy' : 'Redeem'} Shares
      </Typography>
      {orderKind !== OrderKind.BUY && (
        <InfoTooltip
          id={'RedeemDebt'}
          tooltipText={
            `You have ${redemptionSharesValidAmount} shares available for redemption. The Company intends to limit the
             aggregate number of Shares ` +
            'that may be redeemed during any calendar year to 12.0% of the weighted average number of Shares ' +
            'outstanding during the prior calendar year (or 1.0% per month, with excess capacity carried over to ' +
            'later months in the calendar year). In the event that the Company does not have sufficient funds available ' +
            'to redeem all of the Shares for which redemption requests have been submitted in any month, such pending ' +
            'requests will be honored on a pro rata basis. For Shareholders who purchased Shares on more than one record' +
            ' date, requests for redemptions will be applied to such Shareholder’s Shares in the order in which they were' +
            ' purchased, on a first in first out basis.'
          }
        />
      )}
    </div>
  );
};

export default DebtFormTitle;
